export const USER_SLICE = 'USER_SLICE';
